/* para V1.1: Herlipto 寄せの小さな挙動まとめ(見た目は assets/para-herlipto.css)
   1. 告知バーの流れる速さを px/秒 で合わせる(PC 約80.6 / SP 約54.2)
   2. ヘッダー: 告知バーが流れ去ったら縮める(115 → 93px)
   3. ハンバーガー: +/− アコーディオンと外側の × を、Dawn のサブメニュー処理より先に受け取る
   4. 商品ページ SP: 「カートに追加」で全画面モーダル(バリアント行)を開く
   5. 商品ページ下: CHECKED ITEMS / RECOMMEND を1つのタブにまとめる */
(function () {
  'use strict';

  /* 0. V1.16(S03): Wishlist King(Swish)の価格表記を店と同じ「¥1,500」に(アプリ既定は「¥1,500 JPY」)。
     Swish の設定 JSON(#wkAppSettings)は、アプリのモジュール(本文末尾の type=module)が読む前に、
     先に実行されるこの defer スクリプトで money.withCurrency だけ false にする。
     正式にはテーマエディタ > アプリ埋め込み > Swish の「通貨コードを表示」を OFF(settings_data.json の
     money_show_currency_code: false)。それが入ればここは何もしない */
  (function swishMoneyWithoutCurrency() {
    try {
      var el = document.getElementById('wkAppSettings');
      if (!el) return;
      var d = JSON.parse(el.textContent);
      if (d && d.settings && d.settings.money && d.settings.money.withCurrency) {
        d.settings.money.withCurrency = false;
        el.textContent = JSON.stringify(d);
      }
    } catch (e) { /* アプリ側の形式が変わったときは既定のまま */ }
  })();

  /* 1. 告知バーの速度 */
  function tuneMarquee() {
    var speed = window.matchMedia('(min-width: 1000px)').matches ? 80.6 : 54.2;
    document.querySelectorAll('.announcement-bar__message').forEach(function (el) {
      var w = el.scrollWidth;
      if (!w) return;
      el.style.animationDuration = Math.max(8, w / 2 / speed).toFixed(1) + 's';
    });
  }

  /* 2. ヘッダーの縮小 */
  function setupCompactHeader() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var bar = document.querySelector('.announcement-bar-section, [id$="__announcement-bar"]');
    var ticking = false;
    function update() {
      ticking = false;
      var threshold = bar ? bar.offsetHeight : 0;
      header.classList.toggle('para-header--compact', window.scrollY > threshold + 1);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* 3. ハンバーガー内のクリック(capture で Dawn の summary/button ハンドラより先に処理) */
  document.addEventListener('click', function (event) {
    var acc = event.target.closest('[data-para-acc]');
    if (acc && acc.closest('header-drawer')) {
      // 既定動作(details の開閉)はそのまま。Dawn の横スライド処理だけ止める
      event.stopPropagation();
      return;
    }
    var close = event.target.closest('[data-para-drawer-close]');
    if (close) {
      event.stopPropagation();
      event.preventDefault();
      var summary = close.closest('details') && close.closest('details').querySelector(':scope > summary');
      if (summary) summary.click();
      return;
    }
    // para V1.26-fix(F-1): ドロワーの中のリンクを押したら、行き先が同じページ(ハッシュだけ違う)でも別のページでも閉じる。
    //   ハッシュだけ違うリンク(展示一覧で NOW SHOWING / PAST)は再読み込みが起きないので、閉じる処理が無いとドロワーが開いたまま残る。
    //   さらにブラウザがハッシュ移動でフォーカスを body へ外すため、Dawn の Esc(header-drawer 要素の keyup)も届かなくなっていた
    var link = event.target.closest('a[href]');
    if (link && event.button === 0 && !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      var hd = link.closest('header-drawer');
      if (hd && drawerOpen(hd)) closeHeaderDrawer(hd, event, true);
    }
  }, true);

  function drawerOpen(hd) {
    var main = hd.querySelector(':scope > details');
    return !!(main && main.hasAttribute('open'));
  }
  // Dawn の HeaderDrawer.closeMenuDrawer(event, メニューのボタン)で閉じる(中の details の open・menu-opening・body の overflow-hidden-*・
  // フォーカストラップを外し、フォーカスをメニューのボタンへ戻す。× や Esc と同じ処理)
  function closeHeaderDrawer(hd, event, refocusAfterNav) {
    var summary = hd.querySelector(':scope > details > summary');
    if (!summary || typeof hd.closeMenuDrawer !== 'function') return;
    hd.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
    // ハッシュ移動はクリックの処理のあとに起き、そこでフォーカスが body へ外れるので、移動のあとでメニューのボタンへ戻す
    if (refocusAfterNav) setTimeout(function () {
      var a = document.activeElement;
      if (!a || a === document.body) summary.focus({ preventScroll: true });
    }, 0);
  }
  // Esc の保険: フォーカスがドロワーの外(body など)にあっても、開いていれば閉じる(ドロワーの中なら Dawn の onKeyUp が処理する)
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    var hd = document.querySelector('header-drawer');
    if (!hd || !drawerOpen(hd) || hd.contains(event.target)) return;
    closeHeaderDrawer(hd, event, false);
  });

  /* 4. 商品ページ SP のバリアント行モーダル */
  function setupVariantRows() {
    document.querySelectorAll('[data-para-vrows]').forEach(function (root) {
      var panel = root.querySelector('[data-para-vrows-panel]');
      var opener = root.querySelector('[data-para-vrows-open]');
      if (!panel || !opener) return;
      function open() {
        panel.classList.add('is-open');
        document.body.classList.add('para-vrows-open');
        var first = panel.querySelector('button:not([disabled])');
        if (first) first.focus();
      }
      function shut() {
        panel.classList.remove('is-open');
        document.body.classList.remove('para-vrows-open');
        opener.focus();
      }
      opener.addEventListener('click', open);
      root.querySelectorAll('[data-para-vrows-close]').forEach(function (b) { b.addEventListener('click', shut); });
      window.matchMedia('(min-width: 750px)').addEventListener('change', function (mq) { if (mq.matches && panel.classList.contains('is-open')) shut(); });
    });
  }

  /* 5. CHECKED ITEMS / RECOMMEND のタブ */
  function setupTabs() {
    var recSection = null;
    var rvSection = null;
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!recSection && s.querySelector('.para-recommend')) recSection = s;
      if (!rvSection && s.querySelector('para-recently-viewed')) rvSection = s;
    });
    if (!recSection || !rvSection) return;
    var rvWrap = rvSection.querySelector('.para-carousel-wrapper');
    var nameOf = function (s, fallback) {
      var h = s.querySelector('.para-carousel__heading');
      return (h && h.textContent.trim()) || fallback;
    };
    var tabs = document.createElement('div');
    tabs.className = 'page-width para-tabs-wrap';
    tabs.innerHTML = '<div class="para-tabs" role="tablist"></div>';
    var list = tabs.firstChild;
    var entries = [
      { section: rvSection, label: nameOf(rvSection, 'CHECKED ITEMS') },
      { section: recSection, label: nameOf(recSection, 'RECOMMEND') }
    ];
    entries.forEach(function (e, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'para-tabs__btn';
      b.setAttribute('role', 'tab');
      b.innerHTML = '<span></span>';
      b.firstChild.textContent = e.label;
      b.addEventListener('click', function () { select(i); });
      e.button = b;
      list.appendChild(b);
      e.section.classList.add('para-tabbed');
    });
    var first = rvSection.compareDocumentPosition(recSection) & Node.DOCUMENT_POSITION_FOLLOWING ? rvSection : recSection;
    first.parentNode.insertBefore(tabs, first);
    // 2つのセクションを隣に並べる(タブの直後)
    tabs.after(entries[0].section);
    entries[0].section.after(entries[1].section);

    // para V1.10: 中身が 0 件のタブは見出しごと隠す。両方 0 件ならタブ列ごと隠す
    // (売り切れ商品で RECOMMEND が 0 件のまま選ばれ、空のタブ見出しだけが出ていた)
    var recWrap = recSection.querySelector('.para-carousel-wrapper');
    var recEl = recSection.querySelector('para-product-recommend');
    function hasItems(wrap) { return !!(wrap && !wrap.hasAttribute('hidden') && wrap.querySelector('.slider__slide, li')); }
    var current = -1;
    function select(i) {
      current = i;
      entries.forEach(function (e, j) {
        var on = j === i;
        e.button.setAttribute('aria-selected', on ? 'true' : 'false');
        e.section.hidden = !on;
      });
      // RECOMMEND を隠すと画面内に入らず関連商品の取得(IntersectionObserver)が走らないので、ここで取りに行く
      if (i !== 1 && recEl && window.customElements) {
        customElements.whenDefined('para-product-recommend').then(function () {
          if (typeof recEl.requestFill === 'function') recEl.requestFill();
        });
      }
    }
    function refresh() {
      var ok = [hasItems(rvWrap), hasItems(recWrap)];
      entries.forEach(function (e, j) { e.button.hidden = !ok[j]; });
      tabs.hidden = !ok[0] && !ok[1];
      if (ok[current]) return;
      if (ok[0]) select(0);
      else if (ok[1]) select(1);
      else if (current !== 1) select(1); // どちらも 0 件: RECOMMEND 側を表示状態にして関連商品の取得を待つ(中身 0 件なので高さは 0)
    }
    refresh();
    if (rvWrap) new MutationObserver(refresh).observe(rvWrap, { attributes: true, childList: true, subtree: true });
    if (recWrap) new MutationObserver(refresh).observe(recWrap, { attributes: true, childList: true, subtree: true });
  }

  /* 6. Pick Up 10 の進捗バー(6px・ドラッグ/クリックでスクロール) */
  function setupProgress() {
    document.querySelectorAll('.exhibition-picks__track').forEach(function (track) {
      var host = track.parentElement;
      if (!host || host.querySelector(':scope > .para-progress')) return;
      var bar = document.createElement('div');
      bar.className = 'para-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="para-progress__thumb"></div>';
      var thumb = bar.firstChild;
      host.appendChild(bar);
      function draw() {
        var sw = track.scrollWidth, cw = track.clientWidth;
        bar.hidden = sw <= cw + 1;
        var ratio = cw / sw;
        thumb.style.width = (ratio * 100) + '%';
        thumb.style.left = (track.scrollLeft / sw * 100) + '%';
      }
      function jump(clientX) {
        var r = bar.getBoundingClientRect();
        var x = (clientX - r.left) / r.width;
        track.scrollLeft = x * track.scrollWidth - track.clientWidth / 2;
      }
      var dragging = false;
      bar.addEventListener('pointerdown', function (e) { dragging = true; bar.setPointerCapture(e.pointerId); jump(e.clientX); });
      bar.addEventListener('pointermove', function (e) { if (dragging) jump(e.clientX); });
      bar.addEventListener('pointerup', function () { dragging = false; });
      track.addEventListener('scroll', draw, { passive: true });
      window.addEventListener('resize', draw);
      draw();
    });
  }

  /* 7. 商品ページのアコーディオン: 高さアニメ 0.4s ease-out(排他にしない) */
  function setupAccordions() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.product__accordion details').forEach(function (d) {
      var summary = d.querySelector('summary');
      var content = d.querySelector('.accordion__content');
      if (!summary || !content || reduce) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.dataset.animating) return;
        d.dataset.animating = '1';
        var done = function () { content.style.height = ''; content.style.transition = ''; delete d.dataset.animating; };
        if (d.open) {
          content.style.height = content.scrollHeight + 'px';
          requestAnimationFrame(function () {
            content.style.transition = 'height .4s ease-out';
            content.style.height = '0px';
          });
          setTimeout(function () { d.open = false; done(); }, 410);
        } else {
          d.open = true;
          content.style.height = '0px';
          requestAnimationFrame(function () {
            content.style.transition = 'height .4s ease-out';
            content.style.height = content.scrollHeight + 'px';
          });
          setTimeout(done, 410);
        }
      });
    });
  }

  /* 8. メニューを開いたらフォーカスを外側の × へ */
  function setupDrawerFocus() {
    var d = document.querySelector('.para-drawer');
    if (!d) return;
    d.addEventListener('toggle', function () {
      if (d.open) setTimeout(function () { var c = d.querySelector('[data-para-drawer-close]'); if (c) c.focus({ preventScroll: true }); }, 50);
    });
  }

  /* 9. Wishlist King(Swish): 商品ページの行ハート / SP 丸ハート
     snippets/para-fav-button.liquid が置く .para-swish-slot に、Swish の公式 web component
     <wishlist-button-product> を差し込む。部品の読み込みは Swish の Code Access(block-code-access.js)と同じく
     app-loader の loader.load() を使う(状態の同期・トグル・/apps/wishlist への保存は Swish 側が行う)。
     data-variant-id を渡す(アプリ設定の Wishlist mode が VARIANT ならバリアント単位、PRODUCT なら商品単位で保存) */
  function setupSwishSlots() {
    if (!document.querySelector('.para-swish-slot') || !window.WishlistKingAppLoaderURL) return;
    var TAG = 'wishlist-button-product';
    function mount(root) {
      (root || document).querySelectorAll('.para-swish-slot').forEach(function (slot) {
        if (slot.querySelector(TAG)) return;
        var el = document.createElement(TAG);
        if (slot.dataset.productHandle) el.dataset.productHandle = slot.dataset.productHandle;
        if (slot.dataset.productId) el.dataset.productId = slot.dataset.productId;
        if (slot.dataset.variantId) el.dataset.variantId = slot.dataset.variantId;
        el.setAttribute('show-icon', '');
        slot.appendChild(el);
      });
    }
    /* Shopify の JS 圧縮が import() を require() に書き換えるため、module スクリプト経由で app-loader を読む */
    function importModule(url) {
      return new Promise(function (resolve, reject) {
        var cb = '__paraSwishLoader' + Date.now();
        var t = setTimeout(function () { delete window[cb]; reject(new Error('Swish app-loader timeout')); }, 15000);
        window[cb] = function (m) { clearTimeout(t); delete window[cb]; resolve(m); };
        var s = document.createElement('script');
        s.type = 'module';
        s.textContent = 'import * as m from ' + JSON.stringify(url) + '; window[' + JSON.stringify(cb) + '](m);';
        document.head.appendChild(s);
      });
    }
    importModule(window.WishlistKingAppLoaderURL).then(function (mod) {
      var a = mod.appSettings && mod.appSettings.assets;
      if (!a || !a.componentWishlistButtonProductJs) return Promise.reject(new Error('Swish assets not available'));
      if (!customElements.get(TAG)) {
        mod.default.load({
          name: TAG,
          customElementName: TAG,
          type: 'lit-component',
          url: a.componentWishlistButtonProductJs,
          dependencies: [{ url: a.componentWishlistButtonProductCss, order: 5 }]
        });
      }
      return customElements.whenDefined(TAG);
    }).then(function () {
      mount(document);
      /* バリアント行が再描画されたら入れ直す */
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          for (var j = 0; j < list[i].addedNodes.length; j++) {
            var n = list[i].addedNodes[j];
            if (n.nodeType === 1 && (n.matches('.para-swish-slot') || n.querySelector('.para-swish-slot'))) { mount(document); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }).catch(function (e) { console.warn('[para] Swish button:', e); });
  }

  /* 10. V1.3 商品画像のライトボックス(元画像を切らずに元の縦横比で最大表示)
     メイン画像は 2:3 cover で見せ、クリック/タップで元画像を開く。Dawn の拡大モーダル(product-media-modal)より先に
     capture で受け取る(動画・3D は Dawn のまま)。画像の URL は snippets/product-thumbnail.liquid の data-para-lb-*。
     前後 = 左右ボタン / スワイプ(横スクロールのスナップ)/ キーボード ←→。閉じる = × / Esc / 画像の外側クリック。
     SP のピンチ拡大はブラウザ標準(touch-action: pan-x pinch-zoom)。開いている間は背面のスクロールを止め、背面を inert にする */
  function setupLightbox() {
    var root = null, track, countNow, countAll, btnPrev, btnNext, btnClose;
    var items = [], index = 0, startIndex = 0, opener = null, gallery = null, inerted = [], scrollTimer;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ICON = {
      close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>',
      prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4l-8 8 8 8" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>',
      next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>'
    };

    function build() {
      root = document.createElement('div');
      root.className = 'para-lb';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-label', '商品画像の拡大表示');
      root.hidden = true;
      root.innerHTML =
        '<p class="para-lb__count" aria-live="polite"><span class="para-lb__now">1</span><span> / </span><span class="para-lb__all">1</span></p>' +
        '<button type="button" class="para-lb__close" aria-label="閉じる">' + ICON.close + '</button>' +
        '<div class="para-lb__track"></div>' +
        '<button type="button" class="para-lb__nav para-lb__nav--prev" aria-label="前の画像">' + ICON.prev + '</button>' +
        '<button type="button" class="para-lb__nav para-lb__nav--next" aria-label="次の画像">' + ICON.next + '</button>';
      document.body.appendChild(root);
      track = root.querySelector('.para-lb__track');
      countNow = root.querySelector('.para-lb__now');
      countAll = root.querySelector('.para-lb__all');
      btnPrev = root.querySelector('.para-lb__nav--prev');
      btnNext = root.querySelector('.para-lb__nav--next');
      btnClose = root.querySelector('.para-lb__close');
      btnClose.addEventListener('click', close);
      btnPrev.addEventListener('click', function () { go(index - 1); });
      btnNext.addEventListener('click', function () { go(index + 1); });
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { setIndex(Math.round(track.scrollLeft / (track.clientWidth || 1))); }, 60);
      }, { passive: true });
      /* 画像の外側(余白)をクリックしたら閉じる */
      track.addEventListener('click', function (e) { if (!e.target.closest('img')) close(); });
      root.addEventListener('keydown', onKey);
      window.addEventListener('resize', function () { if (!root.hidden) track.scrollLeft = index * track.clientWidth; });
    }

    function load(i) {
      var slide = track.children[i];
      if (!slide) return;
      var img = slide.querySelector('img');
      if (img && !img.getAttribute('src')) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
      }
    }

    function setIndex(i) {
      index = Math.max(0, Math.min(items.length - 1, i));
      countNow.textContent = index + 1;
      btnPrev.disabled = index === 0;
      btnNext.disabled = index === items.length - 1;
      load(index); load(index + 1); load(index - 1);
      Array.prototype.forEach.call(track.children, function (s, j) { s.setAttribute('aria-hidden', j === index ? 'false' : 'true'); });
    }

    function go(i) {
      if (i < 0 || i >= items.length) return;
      setIndex(i);
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    function focusables() {
      return [btnClose, btnPrev, btnNext].filter(function (b) { return !b.disabled && !b.hidden && b.offsetParent !== null; });
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      else if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) { e.preventDefault(); return; }
        var at = f.indexOf(document.activeElement);
        e.preventDefault();
        var next = e.shiftKey ? (at <= 0 ? f.length - 1 : at - 1) : (at === f.length - 1 ? 0 : at + 1);
        f[next].focus();
      }
    }

    function open(list, start, from) {
      if (!root) build();
      items = list; opener = from; startIndex = start;
      gallery = from.closest('media-gallery');
      track.innerHTML = '';
      items.forEach(function (it, i) {
        var fig = document.createElement('figure');
        fig.className = 'para-lb__slide';
        fig.setAttribute('role', 'group');
        fig.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
        var img = document.createElement('img');
        img.alt = it.alt || '';
        img.decoding = 'async';
        img.sizes = '100vw';
        if (it.w && it.h) { img.width = it.w; img.height = it.h; }
        img.dataset.src = it.src;
        if (it.srcset) img.dataset.srcset = it.srcset;
        fig.appendChild(img);
        track.appendChild(fig);
      });
      countAll.textContent = items.length;
      root.classList.toggle('para-lb--single', items.length < 2);

      /* 背面スクロールのロック(スクロールバー分のずれを補正)+ 背面を inert に */
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--para-lb-sbw', sbw + 'px');
      document.documentElement.classList.add('para-lb-open');
      inerted = [];
      Array.prototype.forEach.call(document.body.children, function (el) {
        if (el !== root && !el.inert && el.tagName !== 'SCRIPT') { el.inert = true; inerted.push(el); }
      });

      root.hidden = false;
      track.scrollLeft = start * track.clientWidth;
      setIndex(start);
      requestAnimationFrame(function () {
        track.scrollLeft = start * track.clientWidth;
        root.classList.add('is-open');
      });
      btnClose.focus({ preventScroll: true });
    }

    function close() {
      if (!root || root.hidden) return;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('para-lb-open');
      inerted.forEach(function (el) { el.inert = false; });
      inerted = [];
      /* ライトボックスで送った画像をギャラリー側にも反映し、その画像にフォーカスを戻す */
      var target = opener;
      var cur = items[index];
      if (index !== startIndex && cur && gallery && typeof gallery.setActiveMedia === 'function') {
        try { gallery.setActiveMedia(cur.mediaId, false); } catch (e) {}
        if (cur.button) target = cur.button;
      }
      if (target) target.focus({ preventScroll: true });
    }

    function collect(from) {
      var scope = from.closest('media-gallery') || from.closest('.product__media-list') || document;
      var list = [], start = 0;
      scope.querySelectorAll('.product__media-list .product__media-item').forEach(function (li) {
        var b = li.querySelector('button[data-para-lb-src]');
        /* PC のサムネ表示では選択中以外の li は display:none だが、ライトボックスでは全画像を送れるようにする */
        if (!b || li.classList.contains('product__media-item--variant')) return;
        if (b === from) start = list.length;
        list.push({
          src: b.dataset.paraLbSrc,
          srcset: b.dataset.paraLbSrcset,
          w: parseInt(b.dataset.paraLbW, 10) || 0,
          h: parseInt(b.dataset.paraLbH, 10) || 0,
          alt: b.dataset.paraLbAlt,
          mediaId: li.dataset.mediaId,
          button: b
        });
      });
      return { list: list, start: start };
    }

    /* Dawn の modal-opener より先に受け取る(capture) */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-para-lb-src]');
      if (!b || !b.closest('.product__media-list')) return;
      e.preventDefault();
      e.stopPropagation();
      var c = collect(b);
      if (!c.list.length) return;
      open(c.list, c.start, b);
    }, true);
  }

  /* 11. (V1.16 修正)ヘッダーのハートの件数(Swish)は sections/header.liquid のインライン <script type="module"> に移した。
     Shopify はテーマの .js アセットを配信時に変換し、動的 import() を require() に書き換えるため、ここでは動かなかった */

  function init() {
    setupLightbox();
    setupSwishSlots();
    setupAccordions();
    setupDrawerFocus();
    tuneMarquee();
    setupCompactHeader();
    setupVariantRows();
    setupTabs();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(tuneMarquee, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tuneMarquee);
    /* V1.22(INSP17-2): 告知バーの書体(見出しの書体・swap)が読み込まれると文言の幅が変わる。始まりの位置は CSS で左端に固定した
       (assets/para-herlipto.css の告知バー)。ここでは translateX(-50%) の移動量だけが先に変わって流れが跳ねないよう、
       幅が変わったその描画の前に時間を合わせ直す(ResizeObserver は描画の前に呼ばれる)。速度 = 幅 ÷ 2 ÷ 時間 を保つので、位置は連続する */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { tuneMarquee(); });
      document.querySelectorAll('.announcement-bar__message').forEach(function (el) { ro.observe(el); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
